import { jsx as e, jsxs as b, Fragment as C } from "react/jsx-runtime";
import { useState as _, useMemo as g } from "react";
import k from "country-codes-list";
import { hasFlag as y } from "country-flag-icons";
import w from "../../icons/logo.js";
import O from "../../icons/menu.js";
import { PublishActiveSvg as j, PublishSvg as A, NotificationsActiveSvg as $, NotificationsSvg as H } from "../../icons/index.js";
import { A as M } from "../../../plans-BhwjptmF.js";
import D from "../../forms/base.js";
import "../../../index-D7lh-hNF.js";
import { Button as u } from "../../forms/button/index.js";
import F from "../../forms/select/index.js";
import { b as L, B as T } from "../../../base-dropdown-menu-hover-BGJV3M-p.js";
import { g as z } from "../../../unicode-CvjWOFlF.js";
import '../../../assets/header.css';const I = "_header_1rb9h_1", t = {
  header: I,
  "header--action": "_header--action_1rb9h_12",
  "header--action--brand": "_header--action--brand_1rb9h_19",
  "header--nav": "_header--nav_1rb9h_29",
  "header--nav--links": "_header--nav--links_1rb9h_37",
  "header--nav--links--link": "_header--nav--links--link_1rb9h_47",
  "header--nav--action": "_header--nav--action_1rb9h_57",
  "header--nav--action--support": "_header--nav--action--support_1rb9h_62",
  "header--nav--action--user": "_header--nav--action--user_1rb9h_79"
}, E = k.customList(
  "countryCode",
  "{countryNameLocal}"
);
function x({
  countryValue: i,
  flag: n,
  hideCountryNameOnMobile: a = !1
}) {
  return /* @__PURE__ */ b(
    "p",
    {
      className: "b-flex b-items-center b-gap-1 b-justify-start b-m-0 b-py-1 b-px-2 b-text-black b-text-sm b-w-full b-text-clip b-overflow-hidden",
      "data-value": i,
      children: [
        /* @__PURE__ */ e("span", { className: "", children: n }),
        /* @__PURE__ */ b(
          "span",
          {
            className: `b-text-nowrap b-text-clip b-overflow-hidden ${a ? "b-hidden md:b-inline-flex" : ""}`,
            children: [
              " ",
              i
            ]
          }
        )
      ]
    }
  );
}
const f = Object.entries(E).filter(([i]) => y(i)).sort((i, n) => i[0] === "DO" ? -1 : n[0] === "DO" ? 1 : 0).map(([i, n]) => {
  const a = z(i);
  return {
    id: i + n,
    children: /* @__PURE__ */ e(x, { countryValue: n, flag: a }),
    data: {
      flag: a,
      countryName: n,
      text: `${a} ${n}`
    }
  };
});
function ee({ children: i, href: n, onClick: a }) {
  return /* @__PURE__ */ e(C, { children: n ? /* @__PURE__ */ e(
    "a",
    {
      href: n,
      onClick: a,
      className: t["header--nav--links--link"],
      children: i
    }
  ) : /* @__PURE__ */ e("li", { onClick: a, className: t["header--nav--links--link"], children: i }) });
}
function ne({ children: i }) {
  return /* @__PURE__ */ e("ul", { className: t["header--nav--links"], children: i });
}
function ae({
  contentNav: i = null,
  contentSupport: n = null,
  contentUser: a = null,
  showNav: m = !1,
  showSupport: d = !1,
  showUser: l = !1,
  onClickMenuButton: c = () => {
  },
  onClickLogo: r,
  searchBar: h,
  showSearchBar: s
}) {
  return /* @__PURE__ */ b(
    "header",
    {
      className: `${t.header} b-flex b-py-1 b-bg-white b-items-center md:b-flex-nowrap b-flex-wrap md:b-justify-between md:b-gap-12 b-w-full`,
      children: [
        /* @__PURE__ */ b("div", { className: `${t["header--action"]}`, children: [
          /* @__PURE__ */ e(
            u,
            {
              styleType: "icon",
              className: "b-flex b-items-center b-justify-center ",
              onClick: c,
              children: /* @__PURE__ */ e("div", { className: "b-w-5 b-h-5", children: /* @__PURE__ */ e(O, {}) })
            }
          ),
          /* @__PURE__ */ e(
            "figure",
            {
              className: `${t["header--action--brand"]} ${r ? "hover:b-cursor-pointer" : ""}`,
              onClick: r,
              children: /* @__PURE__ */ e(w, {})
            }
          )
        ] }),
        s && /* @__PURE__ */ b(
          "div",
          {
            className: `b-w-full md:b-order-none b-order-2 md:b-flex b-justify-center ${m && i ? "md:b-hidden" : ""}`,
            children: [
              /* @__PURE__ */ e("div", { className: "b-inline md:b-hidden b-order-1 b-basis-full", children: /* @__PURE__ */ e("hr", { className: "b-my-3 b-mx-0 b-border-none b-bg-gray-300 b-h-[1px]" }) }),
              /* @__PURE__ */ e("div", { className: " b-w-full b-flex b-gap-3 b-items-center b-order-2 md:b-order-0 md:b-mt-0", children: h })
            ]
          }
        ),
        /* @__PURE__ */ b("nav", { className: `${t["header--nav"]}`, children: [
          m && i,
          d ? /* @__PURE__ */ e("div", { className: `${t["header--nav--action--support"]}`, children: n }) : null,
          l ? /* @__PURE__ */ e("div", { className: `${t["header--nav--action--user"]}`, children: a }) : null
        ] })
      ]
    }
  );
}
function G({
  onSelect: i,
  formElementProps: n
}) {
  const [a, m] = _(f[0]), d = (l) => {
    m(l), i(l);
  };
  return /* @__PURE__ */ e(D, { onSubmit: () => {
  }, formElementProps: n, children: /* @__PURE__ */ e(
    F,
    {
      id: "country",
      containerClassname: "b-max-h-60 b-overflow-auto b-z-30 b-min-w-32",
      options: f,
      initial: f[0],
      onSelect: d,
      onSearch: (l, c) => l.filter(
        (r) => r.data.text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(
          c.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
        )
      ),
      children: /* @__PURE__ */ e(
        x,
        {
          countryValue: a.data.countryName,
          flag: a.data.flag,
          hideCountryNameOnMobile: !0
        }
      )
    }
  ) });
}
function v({
  text: i,
  icon: n
}) {
  return /* @__PURE__ */ b("div", { className: "b-flex b-px-2 b-py-1 b-gap-2", children: [
    n && /* @__PURE__ */ e("figure", { className: "icon b-m-0 b-p-0 b-flex b-items-center b-justify-center", children: n }),
    /* @__PURE__ */ e("span", { children: i })
  ] });
}
function q({ options: i, actions: n }) {
  const a = Object.entries(i).map(([d, l]) => ({
    id: d,
    children: /* @__PURE__ */ e(v, { ...l }),
    containerProps: { onClick: l.onClick }
  })), m = Object.entries(n).map(([d, l]) => ({
    id: d,
    children: /* @__PURE__ */ e(v, { ...l }),
    containerProps: { onClick: l.onClick }
  }));
  return /* @__PURE__ */ e(
    L,
    {
      actions: m,
      options: a
    }
  );
}
function ie({
  showAvatarUser: i,
  avatarUserProps: n,
  countrySelectProps: a,
  loginButtonProps: m,
  notificationsProps: d,
  publishPropertiesProps: l,
  showCountrySelect: c,
  showLoginButton: r,
  showNotifications: h,
  showPublishProperties: s
}) {
  const o = g(() => {
    const N = [...f];
    return a != null && a.moreOptionsChildren && N.unshift(...a.moreOptionsChildren), N;
  }, [a == null ? void 0 : a.moreOptionsChildren]);
  return /* @__PURE__ */ b("div", { className: "b-flex b-items-center b-gap-3", children: [
    c && a && /* @__PURE__ */ e("span", { className: "b-bg-gray-100 hover:b-bg-gray-200 b-duration-100", children: /* @__PURE__ */ e(
      G,
      {
        options: o,
        initialOption: o[0],
        onSelect: a == null ? void 0 : a.onSelect,
        formElementProps: { className: "b-w-auto md:b-w-48" }
      }
    ) }),
    (s || h) && /* @__PURE__ */ b("div", { className: "b-flex", children: [
      s && /* @__PURE__ */ e(
        u,
        {
          className: "!b-flex b-items-center b-justify-center",
          styleType: "icon",
          onClick: l == null ? void 0 : l.onClick,
          children: /* @__PURE__ */ e(
            "img",
            {
              className: "b-h-6 b-w-6 md:b-h-7 md:b-w-7",
              src: l != null && l.isActive ? j : A,
              alt: "Publish a property"
            }
          )
        }
      ),
      h && /* @__PURE__ */ e(
        u,
        {
          className: "!b-flex b-items-center b-justify-center",
          styleType: "icon",
          tip: d == null ? void 0 : d.tipText,
          onClick: d == null ? void 0 : d.onClick,
          children: /* @__PURE__ */ e(
            "img",
            {
              className: "b-h-6 b-w-6 md:b-h-7 md:b-w-7",
              src: d != null && d.isActive ? $ : H,
              alt: "Go to notifications"
            }
          )
        }
      )
    ] }),
    i && /* @__PURE__ */ e(
      T,
      {
        position: "bottom",
        className: " b-flex b-items-center b-z-50",
        menuContainerProps: { className: "b-right-0 b-pt-1" },
        onlyOpenOnClick: !0,
        menu: /* @__PURE__ */ e(
          q,
          {
            actions: (n == null ? void 0 : n.menuActions) || {},
            options: (n == null ? void 0 : n.menuOptions) || {}
          }
        ),
        children: /* @__PURE__ */ e(
          "img",
          {
            className: "b-rounded-full b-w-8 b-h-8",
            src: (n == null ? void 0 : n.imageUrl) || M,
            alt: "User avatar"
          }
        )
      }
    ),
    r && /* @__PURE__ */ e(
      u,
      {
        className: "b-min-w-40 b-h-8 b-text-nowrap",
        styleType: "secondary",
        onClick: m == null ? void 0 : m.onClick,
        children: m == null ? void 0 : m.text
      }
    )
  ] });
}
export {
  x as CountryOptionChildren,
  ae as Header,
  q as HeaderAvatarMenu,
  G as HeaderCountrySelect,
  ee as HeaderNavLink,
  ne as HeaderNavLinks,
  ie as HeaderUserActions
};
